import { useQuery } from "@tanstack/react-query";
import { listLdapSettings } from "@/services/ldapSettingsApi";
import { LdapSettingDTO } from "@/types/api";

export interface IdentityProvider {
  id: string;
  name: string;
  type: string;
  status: string;
  created_at: string;
  updated_at: string;
}

export const useIdentityProviders = () => {
  return useQuery({
    queryKey: ['identity_providers'],
    queryFn: async () => {
      const settings = await listLdapSettings();
      
      // Map LDAP settings to the IdentityProvider shape used by the UI
      return settings.map((s: LdapSettingDTO): IdentityProvider => ({
        id: s.id || '',
        name: s.name,
        type: 'LDAP',
        status: 'connected',
        created_at: '',
        updated_at: '',
      }));
    }
  });
};
